/* eslint-disable no-void */
/* eslint-disable max-len */
/* eslint-disable no-console */

import { PORTAL_LM_WINDOW } from "../Constants";
import { showErrorMessage } from "./hook/useDialogStateHelper";
import { isOpenLmWindow } from "./hook/useWindowStateHelper";

export type LMWindow = Window & {
    /**
     * ログインURL
     */
    lmLoginPath?: string;
    /**
     * 閲覧用URL
     */
    lmPreviewPath?: string;
};

export default class WindowOpener {
    private static observeClosed(window: Window | null, onClose?: () => void): void {
        // 別タブまたは閉じた際のコールバック未設定の場合は何もしない
        if (!window || !onClose) {
            return;
        }

        // 別タブが閉じたか監視
        if (window.closed) {
            // 閉じていたらコールバック実行
            onClose();
        } else {
            // 閉じていない場合は500ms毎に監視
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            setTimeout(() => this.observeClosed(window, onClose), 500);
        }
    }

    static open(url: string, onOpen?: (sub: LMWindow) => void, onClose?: () => void): LMWindow | null {
        // 別タブ表示
        const sub = window.open(url, PORTAL_LM_WINDOW);

        // 別タブを開いた際に実行
        if (onOpen) {
            onOpen(sub!);
        }

        // 別タブが閉じたか監視
        this.observeClosed(sub, onClose);

        return sub;
    }

    static openLmWindow(fetch: () => Promise<void>): void {
        if (!isOpenLmWindow()) {
            void fetch();
        } else {
            showErrorMessage({
                message:
                    "「受講画面」「管理者メニュー画面」は、複数の画面を同時に起動できません。<br/>既に開いている画面を閉じてから再度実行してください。",
            });
        }
    }

    static openBase64Data(base64: string, type: string): void {
        const sub = window.open("");
        if (!sub) return;
        sub.document.write(`<iframe width="100%" height="100%" src="data:${type};base64, ${base64}" style="border:0px none;"></iframe>`);
        // sub.document.write(`<iframe width="100%" height="100%" src="${base64}" style="border:0px none;"></iframe>`);
    }
}
